import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

/**
 * Título do browser para `/aceite-de-termos/:termId` (identificador visível no separador).
 */
export const resolveTermsAcceptanceTitle: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => {
  const termId = route.paramMap.get('termId');
  if (!termId) {
    return 'Aceite de termos';
  }
  return `Aceite de termos · ${termId}`;
};

/**
 * Título para detalhe de termo no backoffice (`gestao-de-termos/:id`).
 */
export const resolveTermDetailTitle: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => {
  const id = route.paramMap.get('id');
  if (!id) {
    return 'Detalhe do termo';
  }
  return `Termo · ${id}`;
};

/**
 * Título para visualização de material (`…/:id/visualizar-material`).
 */
export const resolveMaterialViewerTitle: ResolveFn<string> = (
  route: ActivatedRouteSnapshot
) => {
  const id = route.paramMap.get('id');
  if (!id) {
    return 'Visualizar material';
  }
  return `Material · ${id}`;
};
